import React, { useState, useEffect } from "react";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import SearchInput from "@/components/SearchInput/SearchInput";

interface MyEmailNotificationsFiltersProps {
  filters: {
    searchTerm: string;
    approved: string; // "all" | "approved" | "unapproved"
    sent: string; // "all" | "sent" | "unsent"
  };
  onFilterChange: (filterKey: string, value: string) => void;
}

const MyEmailNotificationsFilters: React.FC<
  MyEmailNotificationsFiltersProps
> = ({ filters, onFilterChange }) => {
  const [searchInput, setSearchInput] = useState(filters.searchTerm);
  const debouncedSearch = useDebouncedValue(searchInput, 500);

  useEffect(() => {
    if (debouncedSearch !== filters.searchTerm) {
      onFilterChange("searchTerm", debouncedSearch);
    }
  }, [debouncedSearch, filters.searchTerm, onFilterChange]);

  return (
    <div className="mb-4 space-y-4">
      <SearchInput
        onChange={setSearchInput}
        placeholder="Search by subject..."
        value={searchInput}
      />

      <div className="flex space-x-4 items-center">
        <label className="flex flex-col">
          <span className="text-sm font-medium">Status</span>
          <select
            className="border rounded p-1"
            onChange={(e) => onFilterChange("approved", e.target.value)}
            value={filters.approved}
          >
            <option value="all">All Notifications</option>
            <option value="approved">Approved Only</option>
            <option value="unapproved">Pending Approval</option>
          </select>
        </label>

        <label className="flex flex-col">
          <span className="text-sm font-medium">Delivery</span>
          <select
            className="border rounded p-1"
            onChange={(e) => onFilterChange("sent", e.target.value)}
            value={filters.sent}
          >
            <option value="all">All</option>
            <option value="sent">Sent</option>
            <option value="unsent">Not Sent</option>
          </select>
        </label>
      </div>
    </div>
  );
};

export default MyEmailNotificationsFilters;
